import React from 'react';
import { useSystemAclRoleEditor } from '../hooks/use-system-acl-role-editor.js';
import SystemAclRolePageView from './system-acl-role-page-view.jsx';

function SystemAclRolePageContainer() {
  const state = useSystemAclRoleEditor();
  return <SystemAclRolePageView {...state} />;
}

export default SystemAclRolePageContainer;
